import { render } from "./CorrectView.vue?vue&type=template&id=6f5df3d2&scoped=true&ts=true"
import script from "./CorrectView.vue?vue&type=script&lang=ts"
export * from "./CorrectView.vue?vue&type=script&lang=ts"

import "./CorrectView.vue?vue&type=style&index=0&id=6f5df3d2&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5df3d2"]])

export default __exports__